import { render } from "./buttonApp.vue?vue&type=template&id=7c3f5751&scoped=true"
import script from "./buttonApp.vue?vue&type=script&lang=js"
export * from "./buttonApp.vue?vue&type=script&lang=js"

import "./buttonApp.vue?vue&type=style&index=0&id=7c3f5751&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7c3f5751"

export default script